import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/api/auth";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const me = useMe();
  const location = useLocation();

  if (me.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper">
        <span className="font-mono text-[0.78rem] uppercase tracking-widest text-ink-muted">
          Loading…
        </span>
      </div>
    );
  }

  if (!me.data) {
    // In dev, Vite serves the SPA at :5174 but the OAuth callback lands on
    // the .NET origin (:7157). An absolute returnUrl is the only way for the
    // user to bounce back to Vite (and keep HMR). In production the SPA and
    // API are same-origin, so a clean relative path is enough.
    const path = location.pathname + location.search;
    const returnUrl = import.meta.env.DEV
      ? window.location.origin + path
      : path;
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`} replace />;
  }

  return <>{children}</>;
}
